import axios from "axios";

export const verifyPendingInsuranceRequest = async (): Promise<void> => {
  await axios.post(`/api/checkins/insurance_verifications`, {
    verifying_pending_insurance: true,
  });
};
